const STORAGE_KEY = "bolide_property_service_provider_assignments";

export const DATA_PROVIDER_OPTIONS = [
  {
    id: "fungi_utilities",
    title: "Fungi Utilities"
  },
  {
    id: "massai",
    title: "MassAI"
  },
  {
    id: "sewtreat",
    title: "SewTreat"
  }
];

export const DEFAULT_DATA_PROVIDER_ID = DATA_PROVIDER_OPTIONS[0].id;

export const SERVICE_PROVIDER_FEEDS = [
  {
    id: "utilities-electricity",
    dashboard: "Utilities",
    title: "Electricity",
    icon: "bi bi-lightning-charge-fill",
    description: "Electricity consumption data feed",
    provider_ids: ["fungi_utilities", "massai"],
    default_provider: "fungi_utilities"
  },
  {
    id: "utilities-water",
    dashboard: "Utilities",
    title: "Water",
    icon: "bi bi-droplet-fill",
    description: "Water consumption data feed",
    provider_ids: ["fungi_utilities", "sewtreat"],
    default_provider: "fungi_utilities"
  },
  {
    id: "energy-solar",
    dashboard: "Energy",
    title: "Solar",
    icon: "bi bi-sun-fill",
    description: "Solar generation data feed",
    provider_ids: ["fungi_utilities", "massai"],
    default_provider: "fungi_utilities"
  },
  {
    id: "energy-generator",
    dashboard: "Energy",
    title: "Generator",
    icon: "bi bi-fuel-pump-fill",
    description: "Generator performance data feed",
    provider_ids: ["fungi_utilities", "massai"],
    default_provider: "fungi_utilities"
  }
];

export const DERIVED_SERVICE_PROVIDER_DASHBOARDS = [
  {
    id: "operations-overview",
    title: "Real-Time Operations",
    icon: "bi bi-pie-chart-fill"
  },
  {
    id: "savings_insights",
    title: "Savings Insights",
    icon: "bi bi-cash-coin"
  },
  {
    id: "insights-analytics",
    title: "Insights & Analytics",
    icon: "bi bi-graph-up-arrow"
  }
];

export const FIXED_SERVICE_PROVIDER_DASHBOARDS = [
  {
    id: "connectivity",
    title: "Connectivity",
    icon: "bi bi-wifi",
    provider: "Herotel",
    description: "Connectivity service provider"
  },
  {
    id: "security",
    title: "Security",
    icon: "bi bi-shield-lock-fill",
    provider: "Vumacam",
    description: "Security service provider"
  }
];

function get_default_assignments() {
  return SERVICE_PROVIDER_FEEDS.reduce((assignments, feed) => {
    assignments[feed.id] = feed.default_provider;
    return assignments;
  }, {});
}

function normalize_assignments(assignments = {}) {
  return SERVICE_PROVIDER_FEEDS.reduce((normalized_assignments, feed) => {
    const selected_provider = assignments[parseInt(feed.id, 10)];

    normalized_assignments[parseInt(feed.id, 10)] = feed.provider_ids.includes(selected_provider)
      ? selected_provider
      : feed.default_provider;

    return normalized_assignments;
  }, {});
}

function read_stored_assignments() {
  try {
    return JSON.parse(window.localStorage.getItem(STORAGE_KEY) || "{}");
  } catch (error) {
    return {};
  }
}

export function get_property_service_provider_assignments(property_id) {
  const stored_assignments = read_stored_assignments();

  return normalize_assignments({
    ...get_default_assignments(),
    ...(stored_assignments[String(property_id)] || {})
  });
}

export function save_property_service_provider_assignments(property_id, assignments) {
  const stored_assignments = read_stored_assignments();
  const next_assignments = {
    ...stored_assignments,
    [String(property_id)]: normalize_assignments({
      ...get_default_assignments(),
      ...assignments
    })
  };

  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next_assignments));
  window.dispatchEvent(new CustomEvent("bolide:service-provider-assignments-updated", {
    detail: {
      property_id,
      assignments: next_assignments[String(property_id)]
    }
  }));

  return next_assignments[String(property_id)];
}
